import { useMemo } from 'react';
import { TourType } from '@/Components/Tour/Tour';
import { useLocalization } from '@/Hooks';

export function useOnlineArchiveReports() {
  const {
    tours: {
      Accounting: { ReportTour },
    },
  } = useLocalization();

  const pageTour = useMemo<TourType>(
    () => ({
      id: 'pageTour',
      title: ReportTour.Title,
      steps: [
        {
          content: ReportTour.Step1.Text,
          placement: 'auto',
          target: '#reports',
          title: ReportTour.Step1.Title,
          disableBeacon: true,
          link: ReportTour.Step1.DetailsLink,
        },
        {
          content: ReportTour.Step2.Text,
          placement: 'auto',
          target: '#reportInfo',
          title: ReportTour.Step2.Title,
          disableBeacon: true,
          link: ReportTour.Step2.DetailsLink,
        },
        {
          content: ReportTour.Step3.Text,
          placement: 'auto',
          target: '#createReport',
          title: ReportTour.Step3.Title,
          disableBeacon: true,
          link: ReportTour.Step3.DetailsLink,
        },
        {
          content: ReportTour.Step4.Text,
          placement: 'auto',
          target: '#createReportWithService',
          title: ReportTour.Step4.Title,
          disableBeacon: true,
          link: ReportTour.Step4.DetailsLink,
        },
        {
          content: ReportTour.Step5.Text,
          placement: 'top',
          target: '#reportsTable',
          title: ReportTour.Step5.Title,
          disableBeacon: true,
          link: ReportTour.Step5.DetailsLink,
        },
        {
          content: ReportTour.Step6.Text,
          placement: 'auto',
          target: '.dx-toolbar-after',
          title: ReportTour.Step6.Title,
          disableBeacon: true,
          link: ReportTour.Step6.DetailsLink,
          spotlightPadding: 0,
          styles: {
            spotlight: {
              maxWidth: '500px',
            },
          },
        },
        {
          content: ReportTour.Step7.Text,
          placement: 'auto',
          target: '#tableImportButton',
          title: ReportTour.Step7.Title,
          disableBeacon: true,
          link: ReportTour.Step7.DetailsLink,
          styles: {
            spotlight: {
              minWidth: '65px',
            },
          },
        },
        {
          content: ReportTour.Step8.Text,
          placement: 'auto',
          target: '#adScreen',
          title: ReportTour.Step8.Title,
          disableBeacon: true,
          link: ReportTour.Step8.DetailsLink,
        },
      ],
    }),
    [ReportTour],
  );

  return [pageTour];
}
